module.exports = __webpack_public_path__ + "assets/img/iphone.3e261b7f6244c15c94a28afae1800844.svg";